import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useFeatureNavigation } from '../services/featureNavigation';

const DialogNavigationWrapper = ({ children, onClose }) => {
    const [isNavigating, setIsNavigating] = useState(false);
    const { navigateToFeature, returnToSource } = useFeatureNavigation(() => {
        // Navigation complete callback
    });

    const handleFeatureNavigation = async (featureRef, sourceRef) => {
        setIsNavigating(true);
        await navigateToFeature(featureRef, sourceRef);
    };

    const handleReturnFromNavigation = async () => {
        await returnToSource();
        setIsNavigating(false);
    };

    // Expose navigation methods to child components via React.Children.map
    const childrenWithNavigation = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onNavigateToFeature: handleFeatureNavigation
            });
        }
        return child;
    });

    // Split out the navigation state className
    const overlayClassName = `fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 
        transition-all duration-300 ${isNavigating ? 'opacity-0 pointer-events-none' : 'opacity-100'}`;

    const dialogClassName = `bg-white rounded-lg max-w-2xl w-full shadow-xl transform transition-transform duration-300
        ${isNavigating ? 'translate-y-full' : 'translate-y-0'}`;

    return (
        <>
            <div className={overlayClassName} role="dialog">
                <div className={dialogClassName}>
                    {childrenWithNavigation}
                </div>
            </div>

            {/* Floating return button */}
            {isNavigating && (
                <div className="fixed bottom-4 right-4 z-50">
                    <button
                        onClick={handleReturnFromNavigation}
                        className="bg-white px-4 py-2 rounded-lg shadow-lg border flex items-center gap-2 
                                 hover:bg-gray-50 transition-colors"
                    >
                        <ChevronLeft className="w-4 h-4" />
                        Return to Dialog
                    </button>
                </div>
            )}
        </>
    );
};

export default DialogNavigationWrapper;